export default __webpack_public_path__ + "locales/az/Common.json?hash=0caac221711c364e264fa1a362442e0b";